import Layout from "layouts/Layout";
import Starter from "views/Starter";

export default function Rejected() {
  return (
        <Layout  active={"Rejected"}>
        <Starter filterStatus='rejected' />
    </Layout>
  )
}
